export const UPDATE_TYPE = 'UPDATE_TYPE';
